import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface AdminGuardProps {
  children: React.ReactNode;
}

/**
 * Bounces admins with mustEnrollTotp=true to the enrollment page,
 * UNLESS they're already on it. Render this around every /admin/* route.
 */
export default function AdminGuard({ children }: AdminGuardProps) {
  const { user } = useAuth();
  const location = useLocation();

  if (user?.mustEnrollTotp && location.pathname !== '/admin/setup-2fa') {
    return <Navigate to="/admin/setup-2fa" replace />;
  }

  return <>{children}</>;
}
